module.exports = __webpack_public_path__ + "img/solution-pc-50.58afe42b.png";